import { render } from "./PayImageWallShell.vue?vue&type=template&id=70fed46b&scoped=true"
import script from "./PayImageWallShell.vue?vue&type=script&lang=js"
export * from "./PayImageWallShell.vue?vue&type=script&lang=js"

import "./PayImageWallShell.vue?vue&type=style&index=0&id=70fed46b&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fed46b"]])

export default __exports__